export default __webpack_public_path__ + "static/media/cloc-gold.9a63009b.svg";